import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable, of } from 'rxjs';
import urlJoin from 'url-join';
import { BaseHttpService } from '.';
import { RequestLogCategory, RequestLogSystem, ResponseLogCategory, ResponseLogSystem } from '../../../features/admin/models';
import { IChangeLogEntry, IErrorLogEntry, IPageLogEntry } from '../models';
import { fwHttpClientUtils } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LoggingService extends BaseHttpService {
  pageEndpoint: string = 'logs/pages';
  errorEndpoint: string = 'logs/errors';
  changeEndpoint: string = 'logs/changes';

  errorGridEndpoint: string = 'logs/errorsGrid';

  constructor(http: HttpClient
    , @Inject(OKTA_AUTH) auth: OktaAuth
    , private router: Router
    , @Inject('CONFIG_SETTINGS') configSettings: any) {

    super(http,auth);

    const genSettings = configSettings[<any>'general'];

    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
  }

  async logPageView(url: string
    , user: string   // Do not wish the client to be able to define who saw what, should come from the claims resolved server side
    , token: string) {

    // Ignore login and '/'
    if (url == '/' || url.startsWith('/login')) {
      return;
    }

    const item = {
      url: url
    };

    const apiUrl = urlJoin(this.baseUrl, this.pageEndpoint);

    this.saveItem(item, true, apiUrl, this.getHttpBearerHeaders(token))
      .subscribe(err => console.log(err));
  }

  async log(item: any, user: string) {

    // Dont use a token. error logging should AllowAnonymous
    const ditem = {
      loggedBy: user,
      url: this.router.url,
      message: item.message || item || 'Unknown client error',
      stack: item.stack || ''
    };

    //const apiUrl = urlJoin(this.baseUrl, this.errorEndpoint);
    const apiUrl = `${this.baseUrl}logs/system`;
    const token = this.getToken();
    if (token) {
    this.saveItem(ditem, true, apiUrl, this.getHttpBearerHeaders(token))
        .subscribe(); //err => console.log(err)
    }
  }

  getLogSystem$(req: RequestLogSystem): Observable<ResponseLogSystem> {
    const token = this.getToken();
    if (!!token) {
      const url = `${this.baseUrl}logs/system`;
      const httpOptions = {
        headers: this.getHttpBearerHeaders(token),
        params: fwHttpClientUtils.toHttpParams(req),
       'Ocp-Apim-Subscription-Key': this.apiKey

      };
      return this.http.get<ResponseLogSystem>(url, httpOptions);
    }
    return of(new ResponseLogSystem());
  }

  getLogSystemCategories$(req: RequestLogCategory): Observable<ResponseLogCategory> {
    const token = this.getToken();
    if (!!token) {
      const url = `${this.baseUrl}logs/system-categories`;
      const httpOptions = {
        headers: this.getHttpBearerHeaders(token),
        params: fwHttpClientUtils.toHttpParams(req)
      };
      return this.http.get<ResponseLogCategory>(url, httpOptions);
    }
    return of(new ResponseLogCategory());
  }

  // legacy - will be removed
  getErrorLogs(): Observable<IErrorLogEntry[]> {

    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.errorEndpoint);
      return this.getItems<IErrorLogEntry>(url, this.getHttpBearerHeaders(token));
    }
    else {
      var emptyLogs: IErrorLogEntry[] = [];
      return of(emptyLogs);
    }

  }

  getPageLogs(): Observable<IPageLogEntry[]> {

    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.pageEndpoint);
      return this.getItems<IPageLogEntry>(url, this.getHttpBearerHeaders(token));
    }
    else {
      var emptyLogs: IPageLogEntry[] = [];
      return of(emptyLogs);
    }

  }

  getChangeLogs(): Observable<IChangeLogEntry[]> {

    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.changeEndpoint);
      return this.getItems<IChangeLogEntry>(url, this.getHttpBearerHeaders(token));
    }
    else {
      var emptyLogs: IChangeLogEntry[] = [];
      return of(emptyLogs);
    }

  } 

}
